export const isFileNamePdf = ({ fileName }) => {
	if (String(fileName).toLocaleLowerCase().slice(-4) === ".pdf") {
		return true;
	} else {
		return false;
	}
};

export const isImageFileName = ({ fileName }) => {
	const name = fileName.toLowerCase();
	return name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".jpg");
};

export const getBlobDataUrl = (blobData) => {
	const blob = new Blob([blobData]);
	return URL.createObjectURL(blob);
};
